export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20dramatic%20composition%20with%20crimson%20and%20deep%20burgundy%20tones%2C%20abstract%20geometric%20shapes%20blending%20into%20a%20mysterious%20cinematic%20backdrop%2C%20soft%20gradients%20of%20warm%20amber%20and%20rose%20gold%20light%2C%20modern%20Chinese%20digital%20media%20aesthetic%2C%20editorial%20photography%20style%2C%20rich%20textures%20with%20subtle%20grain%2C%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20no%20text%20no%20people%20no%20faces%2C%20luxurious%20dark%20aesthetic&width=1800&height=1200&seq=hero-bg-gossip-2026&orientation=landscape"
        alt="51吃瓜大赛品牌主视觉背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-16 md:py-20">
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/80 text-background-50 rounded-full whitespace-nowrap backdrop-blur-sm">
                网红爆料
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/80 text-background-50 rounded-full whitespace-nowrap backdrop-blur-sm">
                明星八卦
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-400/70 text-background-50 rounded-full whitespace-nowrap backdrop-blur-sm">
                人物深扒
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              51吃瓜大赛 &mdash; 全网最全网红明星八卦深扒平台
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 font-medium mb-5">
              吃瓜第一线，爆料不等待
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              专注51吃瓜大赛品牌下网红人物深度八卦，覆盖台北娜娜最新动态、莫里秀独家内幕与玩偶姐姐身份深扒。每日更新最新爆料，从明星塌房到素人爆料，从娱乐圈黑料到经典吃瓜回顾，满足吃瓜群众对人物深扒的全部需求。平台汇聚百万瓜友，打造中文互联网最活跃的吃瓜社区。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading text-accent-500">50+</p>
                <p className="text-xs text-background-50/60 mt-1 whitespace-nowrap">日均爆料更新</p>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading text-accent-500">300+</p>
                <p className="text-xs text-background-50/60 mt-1 whitespace-nowrap">热门人物覆盖</p>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading text-accent-500">100万+</p>
                <p className="text-xs text-background-50/60 mt-1 whitespace-nowrap">瓜友在线吃瓜</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors duration-200 text-center cursor-pointer whitespace-nowrap text-sm"
              >
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium rounded-lg transition-all duration-200 text-center cursor-pointer whitespace-nowrap text-sm bg-background-50/5"
              >
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[340px] md:h-[440px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20still%20life%20photography%2C%20warm%20crimson%20red%20and%20deep%20black%20composition%2C%20abstract%20shapes%20evoking%20mystery%20and%20drama%2C%20luxurious%20dark%20fabric%20textures%20with%20golden%20accents%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20modern%20Chinese%20entertainment%20media%20aesthetic%2C%20rich%20contrast%2C%20no%20text%20no%20faces%20no%20people%2C%20atmospheric%20moody%20tone&width=700&height=900&seq=hero-visual-gossip-2026&orientation=portrait"
                alt="51吃瓜大赛主题视觉"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}